<template>
  <div class="edit-dialog" @contextmenu.stop>
    <el-dialog
      title="编辑分享效果"
      width="800px"
      height="800px"
      top="100px"
      custom-class="edit-share"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="default-edit_container">
        <el-scrollbar>
          <div class="default-edit">
            <p class="item-title"><span>|</span> 基础设置</p>
            <div class="base">
              <div class="base-title">
                <div class="base-title-item">
                  <span class="span-title">标题设置</span>
                  <el-input v-model="shareTitle" :maxlength="20" placeholder="请输入20字以内的文本信息"></el-input>
                </div>
                <div class="base-title-item">
                  <span>微信摘要设置</span>
                  <el-input v-model="shareDesc" type="textarea" resize="none" :maxlength="100" placeholder="请输入100字以内的文本信息，例如报纸简介和特色等"> </el-input>
                </div>
              </div>
              <div class="base-item share">
                <span>微信链接封面</span>
                <input type="file" id="uploads" ref="uploadThum" value="imgFile" accept="image/png, image/jpeg, image/gif, image/jpg" @change="setCropImg($event)" style="display:none" />
                <label for="uploads" class="base_content">
                  <template v-if="thumbnail">
                    <img :src="thumbnail" alt="" />
                  </template>
                  <template v-if="!thumbnail">
                    <img src="@imgs/share.png" alt="" />
                  </template>
                  <div>上传链接封面</div>
                </label>
                <CropDialog ref="cropShare" :cropImgUrl="cropImgUrl" @cropConfirm="cropConfirm"></CropDialog>
              </div>
            </div>
            <div class="edit-item">
              <div class="theme">
                <p class="item-title"><span>|</span> 主题颜色</p>
                <el-radio-group v-model="theme">
                  <el-radio class="theme-radio" :label="0">红色</el-radio>
                  <el-radio class="theme-radio" :label="1">蓝色</el-radio>
                </el-radio-group>
              </div>
              <div class="open">
                <p class="item-title"><span>|</span> 报纸打开方式</p>
                <el-radio-group v-model="openMode">
                  <el-radio class="theme-radio" :label="0">直接打开</el-radio>
                  <el-radio class="theme-radio" :label="1">新标签页打开</el-radio>
                </el-radio-group>
              </div>
            </div>
            <p class="item-title"><span>|</span> 背景模板</p>
            <EditBg ref="editBg" :bgType="'epaperGroupBg'" :isDefault="true"></EditBg>
          </div>
          <div class="default-edit-footer" id="edit-footer">
            <div class="edit-footer-item left" @click="saveThen()">保存</div>
            <div class="edit-footer-item right" @click="handleCancel()">取消</div>
          </div>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import compareVipRight from '@components/common/compareVipRight.js'
import EditBg from '../../editDrawer/edit/EditBg'
import CropDialog from '../../editDrawer/edit/CropDialog'
import paperApi from '@api/paperManager'
import bookApi from '@api/setBook'
import { isLogin, base64ToFile, sliceStrPicUrl } from '@/utils'

export default {
  name: 'defaultEdit',
  mixins: [compareVipRight],
  data() {
    return {
      dialogVisible: false,
      id: '',
      shareTitle: '报业集团',
      subTitle: '',
      shareDesc: '',
      thumbnail: '',
      cropImgUrl: '',
      theme: 0,
      openMode: 0
    }
  },
  components: {
    EditBg,
    CropDialog
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.initSetting()
      }
    }
  },
  computed: {
    bookObj() {
      return this.$store.state.config.bookObj
    },
    booksCurrentSubAccount() {
      return this.$store.state.manage.booksCurrentSubAccount
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    initSetting() {
      paperApi.getGroupShareSetting(this.booksCurrentSubAccount || this.userName, 0).then((res) => {
        if (res.status && res.data && res.data.status === 0) {
          const data = res.data.data
          this.shareTitle = data.title
          this.theme = data.topicColor
          this.openMode = data.openMode
          this.thumbnail = data.thumbnail
          this.shareDesc = data.digest
          this.$store.commit('config/UPDATE_CURRENT_BG', data.backgroud)
          if (data.backgroud.length === 1 || data.backgroud.length === 2) {
            this.$store.commit('config/UPDATE_CURRENT_BGIMG', 'template')
          } else {
            this.$store.commit('config/UPDATE_CURRENT_BGIMG', 'custom')
          }
        } else {
          this.cleanData()
        }
      })
    },
    cropConfirm(file) {
      this.thumbnail = file
      document.querySelector('#uploads').value = ''
    },
    setCropImg(e) {
      var _this = this
      //上传图片
      var file = e.target.files[0]
      _this.fileName = file.name
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      let imgFile = new FileReader()
      imgFile.readAsDataURL(file)
      imgFile.onload = (res) => {
        _this.cropImgUrl = res.target.result
        _this.thumbnail = res.target.result
        _this.$refs.uploadThum.value = ''
        _this.$refs.cropShare.dialogVisible = true
        _this.$nextTick(() => {
          _this.$refs.cropShare.init()
        })
      }
    },
    saveThen() {
      isLogin()
      let reg = /<[^>]+>/g
      if (reg.test(this.shareTitle)) {
        this.$message({
          message: '标题不允许输入标签',
          type: 'error'
        })
        return
      }
      this.saveData()
    },
    async saveData() {
      let thumbnail = ''
      if (this.thumbnail && this.thumbnail.includes('data:image')) {
        thumbnail = await this.picChangeUrl('thumbnail', this.thumbnail)
      } else {
        thumbnail = this.thumbnail === 'default' || this.thumbnail === null ? '' : sliceStrPicUrl(this.thumbnail)
      }
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          let currentBgUrl = this.bookObj.currentBgUrl
          let curBgIndex = currentBgUrl ? currentBgUrl.split('.')[0].split('/bg')[1] : null
          let finalBg = curBgIndex
          if (isNaN(parseFloat(curBgIndex)) || this.bookObj.currentBgImg === 'custom') {
            if (currentBgUrl && currentBgUrl.length > 0) {
              finalBg = currentBgUrl.slice(currentBgUrl.indexOf('attach/'))
            }
          }
          let editParams = {
            id: this.id,
            creator: this.booksCurrentSubAccount || this.userName,
            title: this.shareTitle,
            digest: this.shareDesc,
            backgroud: finalBg,
            topicColor: this.theme,
            openMode: this.openMode,
            thumbnail: thumbnail
          }
          const requestHandler = (res) => {
            if (res && res.data && res.data.status === 0) {
              this.dialogVisible = false
              this.$alert('保存成功', '提示', {
                confirmButtonText: '确定'
              })
              resolve()
              return res.data
            } else {
              this.$alert('保存失败', '提示', {
                confirmButtonText: '确定'
              })
              return Promise.reject('error')
            }
          }
          // api 请求直接失败
          const errorHandler = () => {
            return Promise.reject('error')
          }
          paperApi.setGroupShareSetting(editParams).then(requestHandler, errorHandler)
          reject()
        }, 0)
      })
    },
    async picChangeUrl(payload, data) {
      const result = await this.uploadImage(payload, data)
      if (result && result.data.code === 0) {
        return result.data.data
      }
    },
    async uploadImage(payload, data) {
      let params = new FormData()
      let waitData = null
      if (payload !== 'background') {
        waitData = base64ToFile(data) || ''
      } else {
        waitData = data
      }
      params.append('fieldName', payload)
      params.append(payload, waitData)
      return bookApi.uploadPicture(params)
    },
    cleanData() {
      this.shareTitle = '报业集团'
      this.shareDesc = ''
      this.thumbnail = ''
      this.cropImgUrl = ''
      this.theme = 0
      this.openMode = 0
      this.$store.commit('config/UPDATE_CURRENT_BGIMG', 'template')
      this.$store.commit('config/UPDATE_CURRENT_BG', '')
    },
    goBack() {
      this.$emit('goBack')
    }
  },
  created() {
    this.cleanData()
  },
  destroyed() {
    this.cleanData()
  }
}
</script>
<style lang="scss">
.edit-share {
  width: 800px;
  .base {
    .el-input {
      flex: 1;
      height: 24px;
      input {
        height: 100%;
      }
      .el-input__inner {
        font-size: 14px;
        padding: 2px;
        width: 150px;
        height: 24px;
        line-height: 24px;
      }
    }
    .el-textarea {
      flex: 1;
      height: 74px;
      .el-textarea__inner {
        font-size: 14px;
        padding: 2px;
        height: 74px;
      }
    }
  }
  .edit-item {
    .el-radio-group {
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss" scoped>
.edit-dialog {
}
.default-edit_container {
}

.default-edit {
  width: 100%;
  height: 100%;
  padding: 0 0 0 47px;
  .base {
    display: flex;
    .base-title {
      .base-title-item {
        display: flex;
        align-items: baseline;
        margin-bottom: 10px;
        span {
          display: block;
          width: 85px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
    .base-item {
      position: relative;
      display: flex;
      margin-left: 25px;
      img {
        display: block;
        width: 150px;
        height: 150px;
        margin-left: 10px;
      }
      div {
        position: absolute;
        bottom: 0;
        color: #fff;
        background-color: #df5813;
        width: 150px;
        text-align: center;
        font-size: 14px;
        margin-left: 10px;
      }
    }
  }
  .edit-item {
    display: flex;
    .theme {
      width: 45%;
    }
  }
  .item-title {
    font-size: 16px;
    color: #515151;

    span {
      color: #df5813;
    }
  }
}

.default-edit-footer {
  height: 50px;
  line-height: 36px;
  font-size: 14px;
  padding-top: 10px;
  background-color: #ffffff;
  text-align: center;

  .edit-footer-item {
    cursor: pointer;
    display: inline-block;
    height: 36px;
    border: 1px solid #df5813;
    text-align: center;
    width: 100px;
    &.left {
      background-color: #df5813;
      color: #fff;
    }
    &.right {
      margin-left: 30px;
    }
  }
}
</style>
